import {TileViewerConstants} from "../redux_constants/tile.viewer.state.constant";

export const updateAppPosition = (appName, position) => dispatch => {

    dispatch({
        type: TileViewerConstants.UPDATE_TILE_VIEWER_APP_POSITION,
        appPosition: position,
        appName: appName
    });
}

export const updateAppClickTime = (appName) => dispatch => {

    dispatch({
        type: TileViewerConstants.UPDATE_TILE_VIEWER_APP_CLICK_TIME,
        appName: appName
    });
}
